export const dateFormat = (date) => {
    return new Date(date.slice(0, 19).replace('T', ' '))
}